import { TFunction } from "i18next";
import { getPersonValidations } from "@/utils/validations/person";
import { Contract } from "@/types/contract";
import { showEbillInput, showMobilePhone } from "../GeneralContacts/helpers";
import { GeneralContactsFormValues } from "@/screens/Customer/GeneralContacts/form";

export const validationsGeneralContacts = (contract: Contract, t: TFunction<"validations">, isContractRequest: boolean) => {
  const validations = getPersonValidations(t);
  return {
    email: (value: string) => validations.email(value.trim()),
    mobilePhone: (value: string, values: { mobileCountryCode: string }) =>
      showMobilePhone(contract) && validations.mobilePhone(value, values.mobileCountryCode),
    emailEbill: (value: string, values: GeneralContactsFormValues) =>
      showEbillInput(contract, values, isContractRequest) && validations.email(value.trim()),
  };
};
